<template>
  <nav>
    <v-app-bar app color="primary" v-if="$store.state.networkAvailable">
      <!--v-app-bar-nav-icon
        class="secondary--text text--darken-3"
        @click="showDrawer = !showDrawer"
      ></v-app-bar-nav-icon-->
      <v-btn
        v-if="showBackButton"
        icon
        @click="goBack()"
        style="margin-right:5px;"
      >
        <v-icon large>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-btn
        v-if="showRefreshButton"
        icon
        @click="refresh()"
        style="margin-right:5px;"
      >
        <v-icon large>mdi-refresh-circle</v-icon>
      </v-btn>

      <slot>
        <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
          <span class="font-weight-light">{{ appNameFirst }}</span>
          <span class="font-weight-medium">{{ appNameSecond }}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>
      </slot>

      <v-chip
        v-if="isInDevelopment"
        class="ma-2"
        color="error text--darken"
        light
      >
        <v-icon left>mdi-xml</v-icon>TEST SITE
      </v-chip>

      <template v-if="loggedIn">
        <m-menubutton
          v-if="$route.name != 'home'"
          icon="mdi-home"
          @click="$router.push('/home')"
          >Home</m-menubutton
        >
        <m-menu icon="mdi-account" :label="usersFullName">
          <m-item icon="mdi-account-cog" @click="$router.push('/profile')"
            >Edit My Details</m-item
          >
          <m-item icon="mdi-exit-to-app" @click="signOut">Sign Out</m-item>
        </m-menu>
      </template>
    </v-app-bar>

    <v-app-bar app color="primary" v-else>
      <v-btn v-if="showOfflineBackButton" icon @click="goBack()">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="text-uppercase secondary--text text--darken-3">
        <span class="font-weight-light">{{ appNameFirst }}</span>
        <span class="font-weight-medium">{{ appNameSecond }}</span>
      </v-toolbar-title>
      <v-chip class="ma-2" color="warning text--secondary" light>
        <v-icon left>mdi-server-network-off</v-icon>Offline
      </v-chip>
      <slot name="offline"></slot>

      <v-spacer></v-spacer>
      <m-menubutton icon="mdi-refresh" @click="reload">Reload</m-menubutton>
    </v-app-bar>

    <v-dialog v-model="showDialog" width="500">
      <v-card>
        <v-card-title
          class="text-center pa-4"
          :class="
            dialogError
              ? 'error white--text'
              : 'primary secondary--text text--darken-3'
          "
        >
          <v-row justify="center">
            <span class="text-uppercase text-center font-weight-light">
              <span class="font-weight-medium">Log Out</span>
            </span>
          </v-row>
        </v-card-title>

        <v-card-text class="mt-4 mb-0 pb-0 text-center">{{
          dialogText
        }}</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :color="dialogError ? 'error' : 'primary'"
            class="mb"
            :class="
              dialogError ? 'white--text' : 'secondary--text text--darken-3'
            "
            @click="navigateWelcome"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <service-worker />
    <!-- THIS COMPONENT PROVIDES
    ACCESS TO A UI TO UPDATE THE SERVICE WORKER, IT
    NEEDS TO BE ON EVERY PAGE SERVICED BY THE SERVICE
    WORKER -->
  </nav>
</template>

<script>
import GenerateId from "../mixins/generate-id";
import apiMixin from "../mixins/api-request";
import apiQueries from "../mixins/api-endpoints";

export default {
  mixins: [GenerateId, apiMixin, apiQueries],
  props: {
    //drawerItems: Array,
    showDrawer: {
      type: Boolean,
      default: null
    },
    showBackButton: {
      type: Boolean,
      default: true
    },
    showRefreshButton: {
      type: Boolean,
      default: true
    },
    showOfflineBackButton: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      appNameFirst: process.env.MIX_APPNAME_FIRST,
      appNameSecond: process.env.MIX_APPNAME_SECOND,
      productName: process.env.MIX_PRODNAME,
      showDialog: false,
      dialogError: false,
      dialogText: "You Should Never See This Text!",
      // app_env was setup in welcome.blade.php
      isInDevelopment: window.app_env !== "production"
    };
  },
  methods: {
    goBack(evt) {
      this.$router.go(-1);
    },
    refresh(evt) {
      window.location.reload();
    },
    assignIds(drawerVals) {
      // assign a random id to each drawer item if one is not given
      drawerVals.forEach(val => {
        if (!val.hasOwnProperty("id")) {
          this.$set(val, "id", this.generateId());
        }
      });
    },
    signOut(evt) {
      this.apiRequest(this.apiEndpoints.logout)
        .then(r => {
          console.log(r);
          this.dialogError = true;

          if (r.status >= 200 && r.status <= 299) {
            this.dialogError = false;
            this.dialogText = r.body.data.message;
            window.setTimeout(this.navigateWelcome, 5000);
            this.clearToken();
          } else if (r.status == 401) {
            //already logged out (unauthenticated)
            this.dialogError = false;
            this.dialogText = `Already logged out (${r.body.message}).`;
            window.setTimeout(this.navigateWelcome, 5000);
            this.clearToken();
          } else {
            this.dialogText =
              "(" +
              r.status +
              ") " +
              (r.body.message || "Unsupported response from server.");
          }

          this.showDialog = true;
          return r;
        })
        .catch(err => {
          console.log(err);
          return err;
        });
    },
    navigateWelcome() {
      this.showDialog = false; // in case we end up navigating back to this page via guards.
      console.log(this.loadToken());
      console.log(this.dialogError, this.$route.path);
      if (
        !(
          this.dialogError ||
          this.$route.path == "/" ||
          this.$route.path == "/register"
        )
      )
        this.$router.push("/");
    },
    reload() {
      window.location.reload();
    }
  },
  watch: {
    /*
    drawerItems(newVal) {
      this.assignIds(newVal);
    },*/
  },

  computed: {
    loggedIn: function() {
      return !!this.userData;
    },
    usersFullName: function() {
      return this.userData.name;
    },
    userData: function() {
      return this.loadToken();
    }
  }
};
</script>

<style></style>
